export const STATUS_MESSAGES: Record<number, string> = {
  400: "There was a problem with the request. Please verify the request and try again.",
  401: "You are not authorised to access this content. Please log in again.",
  403: "You don't have permission to access this content. Please make sure that you're connected to the VPN.",
  408: "The server took too long to respond. Please try again.",
  500: "There was a problem on the server. Please try again.",
  502: "There was a problem on the server. Please try again.",
  429: "We have reached a resource limit on one of our services. Please wait a few moments and try again.",
}

export const DEFAULT_ERROR_MESSAGE = "Something went wrong. Please try again."
